module.exports = __webpack_public_path__ + "media/eater-type/picky-eater-54d46e3b.svg";